import React from "react";
import PropTypes from "prop-types";
import styles from "./PendingCriticalPartsPopup.module.css";

const PendingCriticalPartsPopup = ({ vc, pendingParts }) => {
  return (
    <div className={styles.AggregateBox}>
      <div className={styles.inner}>
        <div className={styles.vcNumberDisplay}>
          <div style={{ width: "40%", float: "left" }}>VC</div>

          <div
            style={{
              width: "60%",
              float: "left",
              textAlign: "right",
            }}
          >
            {vc}
          </div>
        </div>

        <span className={styles.title}>Pending Critical Parts</span>

        {pendingParts.map((part) => (
          <div className={styles.row} key={part.partNumber}>
            <strong>{part.partNumber}</strong>
          </div>
        ))}
      </div>
    </div>
  );
};

PendingCriticalPartsPopup.propTypes = {
  vc: PropTypes.string.isRequired,
  pendingParts: PropTypes.arrayOf(
    PropTypes.shape({
      partNumber: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default PendingCriticalPartsPopup;
